module.exports = __webpack_public_path__ + "img/team-tamas.588fe60c.jpg";